<template>
    <div class="upload-image-wrapper">
        <div class="upload-preview">
            <img :src="getImage" class="preview-image" v-if="defaultImage">
            <div class="upload-placeholder" v-else-if="!source">
                <i class="fas fa-cloud-upload-alt"></i>
                <span>{{trans('general.no_image_uploaded')}}</span>
            </div>
            <img :src="source" class="preview-image" v-if="source">
        </div>
        <div class="upload-actions">
            <button type="button" class="modern-btn modern-btn-danger" v-if="defaultImage" v-confirm="{ok: confirmRemove(imageSource)}">{{trans('general.remove')}}</button>
            <span id="fileselector" v-show="!source">
                <label class="modern-btn modern-btn-primary upload-label">
                    <input type="file" @change="previewImage" :id="id" class="upload-button">
                    <i class="fas fa-upload"></i> {{buttonText}}
                </label>
            </span>
        </div>
        <div class="upload-actions" v-if="source">
            <button type="button" class="modern-btn modern-btn-primary" @click="uploadImage">{{trans('general.upload')}}</button>
            <button type="button" class="modern-btn modern-btn-secondary" @click="cancelUploadImage">{{trans('general.cancel_upload')}}</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: {
                default: ''
            },
            uploadPath: {
                required: true
            },
            removePath: {
                required: true
            },
            imageSource: {
                default: ''
            },
            buttonText: {
                default: i18n.general.choose_image
            }
        },
        data() {
            return {
                source: '',
                uploaded: '',
                isRemoved: false,
                image: ''
            }
        },
        methods: {
            previewImage(e) {
                let files = e.target.files || e.dataTransfer.files;
                let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
                if(!allowedExtensions.exec($('#'+this.id)[0].files[0].name))
                    toastr.error(i18n.general.file_not_supported);
                else {
                    if (!files.length)
                        return;
                    this.createImage(files[0]);
                }
            },
            createImage(file) {
                let reader = new FileReader();
                reader.onload = (e) => {
                    this.source = e.target.result;
                };
                reader.readAsDataURL(file);
            },
            cancelUploadImage(){
                this.source = '';
                $("#"+this.id).val('');
            },
            uploadImage() {
                let loader = this.$loading.show();
                let data = new FormData();
                
                if($('#'+this.id)[0].files[0].size > helper.getConfig('post_max_size')){
                    toastr.error(i18n.general.file_too_large);
                    return;
                }

                data.append('image', $('#'+this.id)[0].files[0]);
                axios.post('/api'+this.uploadPath,data)
                    .then(response => {
                        toastr.success(response.message);
                        this.source = '';
                        $("#"+this.id).val('');
                        this.uploaded = response.image;
                        this.$emit('uploaded',response.image);
                        loader.hide();
                    }).catch(error => {
                        loader.hide();
                        if(error.response.errors.hasOwnProperty("message")){
                            toastr.error(error.response.errors.message[0]);
                        } else if(error.response.status == 422) {
                            toastr.error(error.response.error);
                            this.cancelUploadImage();
                        }
                        else if(error.response.status == 413 || error.response.status == 500){
                            toastr.error(i18n.general.file_too_large);
                            this.cancelUploadImage();
                        }
                        else
                            helper.showErrorMsg(error);
                    });
            },
            confirmRemove(imageSource){
                return dialog => this.removeImage();
            },
            removeImage() {
                let loader = this.$loading.show();
                axios.delete('/api'+this.removePath)
                    .then(response => {
                        toastr.success(response.message);
                        this.isRemoved = true;
                        this.uploaded = '';
                        this.$emit('removed','');
                        loader.hide();
                    }).catch(error => {
                        loader.hide();
                        if(error.response.errors.hasOwnProperty("message")){
                            toastr.error(error.response.errors.message[0]);
                        } else if(error.response.status == 422) {
                            toastr.error(error.response.error);
                            this.cancelUploadImage();
                        }
                        else {
                            helper.showErrorMsg(error);
                        }
                    });
            }
        },
        computed: {
            defaultImage(){
                return ((this.imageSource && !this.isRemoved) || this.uploaded) ? true : false;
            },
            getImage(){
                return (this.uploaded) ? '/'+this.uploaded : '/'+this.imageSource;
            }
        }
    }
</script>

<style scoped lang="scss">
@import '../../sass/modern-design';

.upload-image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.upload-preview {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 0.5rem;
  border: 2px dashed #cbd5e1;
  min-height: 150px;
  align-items: center;
}

.preview-image {
  max-width: 200px;
  max-height: 200px;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  color: #94a3b8;
  
  i {
    font-size: 3rem;
    opacity: 0.5;
  }
  
  span {
    font-size: 0.875rem;
    font-weight: 500;
  }
}

.upload-actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  justify-content: center;
}

.upload-label {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  
  i {
    font-size: 0.875rem;
  }
}

.upload-button {
  display: none;
}

.modern-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.8rem;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &.modern-btn-primary {
    background: #7B68EE;
    color: #fff;
    
    &:hover {
      background: #6a5acd;
    }
  }
  
  &.modern-btn-danger {
    background: #ef4444;
    color: #fff;
    padding: 0.25rem 0.625rem;
    font-size: 0.7rem;
    line-height: 1.2;
    
    &:hover {
      background: #dc2626;
    }
  }
  
  &.modern-btn-secondary {
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #cbd5e1;
    
    &:hover {
      background: #e2e8f0;
      color: #1e293b;
    }
  }
}
</style>
